import '.cl{font-size:1.125rem;}.ssr-plugin'
import '.gf{line-height:1.75rem;}.ssr-plugin'
import '.c6{text-decoration:none;}.ssr-plugin'
import '.dy{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="cl gf"
    >
      {translations.privacySubtitle}{' '}
      <a className="c6 dy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="c6 dy"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
